import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'googleDocs',
  version: '1.0.0',
  properties: [
    // Properties will be defined based on n8n equivalents
  ]
};

export default schema;
